export function isCode128PartiallyValid(value: string): boolean {
    const isCode128A = /^([ -/]|\d|[A-Z]|\[-`]|\n)*$/;
    const isCode128B = /^([ -~]|\n)*$/;
    const isCode128C = /^(\d\d|\n)*$/;

    return isCode128A.test(value) || isCode128B.test(value) || isCode128C.test(value);
}

export function isValidRuByPhoneVia8(rawPhone: string): boolean {
    const digitsOnly = rawPhone.replace(/\D/g, '');
    const pattern = /^8(9\d{9}|0\d{9}|8\d{10})$/;

    return pattern.test(digitsOnly);
}
